/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_AlignmentInputs */



/**
* | output |
* | --- |
* | "Alignment" |
*
* @param {Options_Watermark_AlignmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_alignment = /** @type {((inputs?: Options_Watermark_AlignmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_AlignmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausrichtung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alineación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对齐方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("配置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संरेखण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhamento")
	return /** @type {LocalizedString} */ ("Alignment")
});